/**
 * Логотип монеты Gram — тот самый значок, которым Telegram подписывает суммы
 * в своих экранах покупки. Взят из исходников Telegram (assets/icons/gram).
 *
 * Оригинал состоит из двух слоёв: огранённый ромб и белая искра поверх него.
 * Здесь они склеены в одну path с fill-rule=evenodd, поэтому искра становится
 * вырезом: значок красится одним currentColor, следует теме и одинаково
 * выглядит на карточке, на кнопке и во вкладке.
 */
const GRAM_PATH =
  // ромб
  "M51.09 0H25.71c-3.38 0-5.07 0-6.598.473a10.6 10.6 0 0 0-3.693 2.015c-1.224 1.03-2.138 " +
  "2.452-3.966 5.296l-8.067 12.55C2.178 22.211 1.574 23.15 1.41 24.14a4.86 4.86 0 0 0 .278 " +
  "2.587c.37.931 1.16 1.721 2.74 3.3l29.977 29.978c1.398 1.398 2.098 2.098 2.904 2.36.709.23 " +
  "1.473.23 2.182 0 .806-.262 1.505-.962 2.904-2.36l29.978-29.978c1.579-1.579 2.368-2.369 " +
  "2.739-3.3a4.86 4.86 0 0 0 .278-2.587c-.164-.989-.768-1.928-1.976-3.807l-8.067-12.55C63.519 " +
  "4.94 62.605 3.52 61.38 2.489A10.6 10.6 0 0 0 57.688.473C56.16 0 54.47 0 51.09 0Z" +
  // искра-вырез
  "M46.286 9.9c.412-1.114 1.988-1.114 2.4 0l2.85 7.7c.171.463.536.828.998 1l7.701 " +
  "2.849c1.114.412 1.114 1.988 0 2.4l-7.7 2.85a1.7 1.7 0 0 0-.999.998l-2.85 7.7c-.412 " +
  "1.115-1.988 1.115-2.4 0l-2.85-7.7a1.7 1.7 0 0 0-.998-.998l-7.7-2.85c-1.115-.412-1.115-1.988 " +
  "0-2.4l7.7-2.85a1.7 1.7 0 0 0 .998-.998Z";

// пропорции оригинала: значок шире, чем выше, поэтому size задаёт высоту
const RATIO = 76 / 64;

export function GramIcon({ size = 16, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={className}
      width={Math.round(size * RATIO)}
      height={size}
      viewBox="0 0 76 64"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path fillRule="evenodd" clipRule="evenodd" d={GRAM_PATH} fill="currentColor" />
    </svg>
  );
}

/** Сумма: логотип Gram + число. Текстовую подпись валюты не дублируем. */
export function GramAmount({
  value,
  size = 16,
  className,
}: {
  value: string | number;
  size?: number;
  className?: string;
}) {
  return (
    <span className={className ? `gram-amount ${className}` : "gram-amount"}>
      <GramIcon size={size} className="gram-amount-icon" />
      {value}
    </span>
  );
}
